import { render, staticRenderFns } from "./ShippingReturnFormV3.vue?vue&type=template&id=b30431f6&scoped=true&"
import script from "./ShippingReturnFormV3.vue?vue&type=script&lang=js&"
export * from "./ShippingReturnFormV3.vue?vue&type=script&lang=js&"
import style0 from "./ShippingReturnFormV3.vue?vue&type=style&index=0&id=b30431f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30431f6",
  null
  
)

export default component.exports